import { useMedia } from 'react-use';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Card } from '@endaoment-frontend/ui/shared';
import { getFormattedMoney } from '@endaoment-frontend/utils';

import { PORTFOLIO_ALLOCATION_SLIDES } from '../../../editable';
import { SectionLabel } from '../../sectionLabel';

import 'swiper/css';
import styles from './PortfolioAllocations.module.scss';

export const PortfolioAllocations = () => {
  const isMobile = useMedia('(max-width: 71rem)', true);
  return (
    <section className={styles['portfolio-allocations']}>
      <SectionLabel text="Crypto-Native Portfolio Allocations" center className={styles['title']} />
      <p className={styles['subtitle']}>Deploy donations directly to crypto assets & DeFi yield to grow your impact.</p>
      <Swiper
        direction="horizontal"
        slidesPerView={isMobile ? 1 : 2}
        spaceBetween={40}
        loop
        modules={[Autoplay]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
      >
        {PORTFOLIO_ALLOCATION_SLIDES.map((props, i) => (
          <SwiperSlide key={i + props.name}>
            <Card className={styles['card']}>
              {props.logo}
              <h4>{props.name}</h4>
              <span>{props.type}</span>
              <p className={styles['description']}>{props.description}</p>
              <p className={styles['deposit-cap']}>
                {props.depositCap ? `Deposit Cap: ${getFormattedMoney(props.depositCap)}` : 'No Deposit Cap'}
              </p>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
      <p className={styles['footer-text']}>
        This fall, we&apos;ll be bringing native crypto investing and wealth management into our contracts and web apps.
      </p>
    </section>
  );
};
